import { createSlice } from '@reduxjs/toolkit';

const CONSECUTIVE_FAILURE_THRESHOLD = 3;

// Statuses that mean the API as a whole is not serving: a maintenance window answers 503,
// and a gateway with no healthy target behind it answers 502 or 504. Deliberately narrower
// than "any 5xx" — a 500 is one endpoint failing, and must not lock the user out of the
// whole app.
export const isServiceUnavailableStatus = (status: unknown): boolean =>
    status === 502 || status === 503 || status === 504;

export interface ApiStatusState {
    consecutiveFailures: number;
    isApiDown: boolean;
    isOnline: boolean;
}

const initialState: ApiStatusState = {
    consecutiveFailures: 0,
    isApiDown: false,
    isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
};

// ==============================|| SLICE - API STATUS ||============================== //

const apiStatus = createSlice({
    name: 'apiStatus',
    initialState,
    reducers: {
        apiRequestFailed(state) {
            state.consecutiveFailures += 1;
            if (state.consecutiveFailures >= CONSECUTIVE_FAILURE_THRESHOLD) {
                state.isApiDown = true;
            }
        },
        apiRequestSucceeded(state) {
            state.consecutiveFailures = 0;
            state.isApiDown = false;
        },
        setApiDown(state, action) {
            state.isApiDown = action.payload;
            if (!action.payload) {
                state.consecutiveFailures = 0;
            }
        },
        setOnlineStatus(state, action) {
            state.isOnline = action.payload;
        },
    },
});

export default apiStatus.reducer;

export const { apiRequestFailed, apiRequestSucceeded, setApiDown, setOnlineStatus } = apiStatus.actions;
